import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQ.css';


const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      category: "General Services",
      questions: [
        {
          question: "What services does Byfotech offer?",
          answer: "We provide comprehensive digital solutions including web development, mobile app development, e-commerce platforms, custom software development, cloud solutions, and tech consulting. We serve businesses of all sizes, from startups to large enterprises."
        },
        {
          question: "How long has Byfotech been in business?",
          answer: "Byfotech is a growing technology company based in Ghana with a focus on delivering world-class digital solutions. We've successfully completed 50+ projects and maintain a 100% client satisfaction rate through our commitment to quality and innovation."
        },
        {
          question: "Do you work with international clients?",
          answer: "Yes, absolutely! While we're based in Ghana, we serve clients globally. We work with businesses across different time zones and have experience with international payment methods, compliance requirements, and cultural considerations."
        },
        {
          question: "What makes Byfotech different from other development companies?",
          answer: "We combine global-standard expertise with competitive pricing and personalized service. Our team stays current with the latest technologies, we provide 24/7 support, and we focus on building long-term partnerships rather than just completing projects."
        }
      ]
    },
    {
      category: "Pricing & Payments",
      questions: [
        {
          question: "How much do your services cost?",
          answer: "Our pricing varies based on project complexity and requirements. Starter packages range from ₵1,500-₵5,000, Professional packages from ₵5,000-₵15,000, and Enterprise solutions from ₵15,000+. We provide detailed quotes after understanding your specific needs."
        },
        {
          question: "Do you offer payment plans or installments?",
          answer: "Yes, we offer flexible payment options including milestone-based payments and installment plans. Typically, we request 30-50% upfront, with the remainder split across project milestones or completion phases."
        },
        {
          question: "What payment methods do you accept?",
          answer: "We accept bank transfers, mobile money (MTN, Vodafone, AirtelTigo), international wire transfers, and can accommodate other payment methods for international clients. All transactions are secure and documented."
        },
        {
          question: "Are there any hidden costs?",
          answer: "No, we believe in transparent pricing. All costs are outlined in our detailed proposals, including development, hosting, third-party integrations, and ongoing maintenance. Any additional costs are discussed and approved before implementation."
        }
      ]
    },
    {
      category: "Development Process",
      questions: [
        {
          question: "What is your development process?",
          answer: "Our process includes: 1) Consultation and requirements gathering, 2) Project planning and wireframing, 3) Design and development, 4) Testing and quality assurance, 5) Client review and revisions, 6) Launch and deployment, 7) Training and handover, 8) Ongoing support."
        },
        {
          question: "How long does a typical project take?",
          answer: "Timeline depends on project scope. Simple websites take 1-3 weeks, professional web applications take 1-3 months, and complex enterprise solutions can take 3-6 months. We provide detailed timelines during the planning phase."
        },
        {
          question: "Can I see progress during development?",
          answer: "Absolutely! We provide regular updates, staging environments for testing, and schedule milestone reviews. You'll have access to development versions and can provide feedback throughout the process."
        },
        {
          question: "What if I need changes during development?",
          answer: "Minor changes within scope are included. Major changes that significantly alter the project requirements may affect timeline and cost, which we'll discuss transparently. We're flexible and work to accommodate reasonable change requests."
        }
      ]
    },
    {
      category: "Technical Details",
      questions: [
        {
          question: "What technologies do you use?",
          answer: "We use modern, industry-standard technologies including React, Node.js, Python, Flutter, React Native, Next.js, and various databases like PostgreSQL and MongoDB. We also work with cloud platforms like AWS, Google Cloud, and Firebase."
        },
        {
          question: "Will my website be mobile-friendly?",
          answer: "Yes, all our websites are fully responsive and mobile-optimized. We follow mobile-first design principles to ensure your site looks and functions perfectly on all devices, from smartphones to desktop computers."
        },
        {
          question: "Do you provide hosting services?",
          answer: "We can arrange hosting through reliable providers and help with setup and configuration. We work with various hosting solutions from shared hosting to cloud infrastructure, depending on your needs and budget."
        },
        {
          question: "Will I own the source code?",
          answer: "Yes, upon full payment, you receive complete ownership of all source code, designs, and assets. We provide documentation and can transfer everything to your preferred platforms or repositories."
        }
      ]
    },
    {
      category: "Support & Maintenance",
      questions: [
        {
          question: "Do you provide ongoing support?",
          answer: "Yes, we offer various support packages ranging from 3 months free support (included in all projects) to comprehensive annual maintenance plans. Support includes bug fixes, security updates, and technical assistance."
        },
        {
          question: "What happens if something breaks after launch?",
          answer: "We provide warranty coverage for any bugs or issues related to our development work. Our support team responds quickly to resolve problems, and we maintain backups to ensure your data is always protected."
        },
        {
          question: "Can you help with website updates and new features?",
          answer: "Absolutely! We offer ongoing development services for adding new features, updating content, improving performance, and scaling your application as your business grows."
        },
        {
          question: "Do you provide training on how to use the system?",
          answer: "Yes, we include user training as part of our service. We provide documentation, video tutorials, and hands-on training sessions to ensure you and your team can effectively manage and use the system."
        }
      ]
    },
    {
      category: "Security & Data",
      questions: [
        {
          question: "How do you ensure my data is secure?",
          answer: "We implement industry-standard security measures including SSL certificates, data encryption, secure authentication, regular backups, and follow GDPR compliance guidelines. All sensitive data is protected using best practices."
        },
        {
          question: "Do you sign Non-Disclosure Agreements (NDAs)?",
          answer: "Yes, we're happy to sign NDAs to protect your business ideas and sensitive information. Confidentiality is important to us, and we treat all client information with the utmost discretion."
        },
        {
          question: "Where is my data stored?",
          answer: "Data is stored on secure, reputable cloud platforms with proper backup systems. We can accommodate specific requirements for data location and compliance needs, especially for international clients."
        }
      ]
    },
    {
      category: "Getting Started",
      questions: [
        {
          question: "How do I get started with my project?",
          answer: "Simply contact us through our website form, email (byfotech@gmail.com), or phone (+233 0555918676). We'll schedule a free consultation to discuss your needs and provide a detailed proposal within 24-48 hours."
        },
        {
          question: "What information should I prepare for our consultation?",
          answer: "Prepare details about your business goals, target audience, desired features, examples of sites/apps you like, budget range, and timeline. Don't worry if you're not sure about everything – we'll help you clarify requirements."
        },
        {
          question: "Do you offer free consultations?",
          answer: "Yes, we provide free initial consultations to understand your project and provide recommendations. This includes project assessment, technology suggestions, and a preliminary proposal at no cost."
        },
        {
          question: "Can you help if I already have a partially completed project?",
          answer: "Absolutely! We can take over incomplete projects, perform code reviews, fix existing issues, or continue development from where previous developers left off. We'll assess the current state and provide a path forward."
        }
      ]
    }
  ];

  return (
    <section className="section faq" id="faq">
      <div className="container">
        <div className="section-header">
          <h2>Frequently Asked Questions</h2>
          <p>Find answers to common questions about our services, processes, and how we can help your business</p>
        </div>
        <div className="faq-content">
          {faqData.map((category, categoryIndex) => (
            <div key={categoryIndex} className="faq-category">
              <h3 className="category-title">{category.category}</h3>
              <div className="faq-items">
                {category.questions.map((item, itemIndex) => {
                  const uniqueIndex = `${categoryIndex}-${itemIndex}`;
                  const isOpen = openItems[uniqueIndex];
                  return (
                    <div key={itemIndex} className={`faq-item${isOpen ? ' active' : ''}`}>
                      <button
                        className="faq-question"
                        onClick={() => toggleItem(uniqueIndex)}
                        aria-expanded={isOpen}
                        aria-controls={`faq-answer-${uniqueIndex}`}
                      >
                        <span>{item.question}</span>
                        <span className={`faq-icon${isOpen ? ' rotate' : ''}`}>+</span>
                      </button>
                      <div
                        id={`faq-answer-${uniqueIndex}`}
                        className={`faq-answer${isOpen ? ' open' : ''}`}
                        aria-hidden={!isOpen}
                      >
                        <div className="faq-answer-content">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="faq-cta">
          <div className="faq-cta-content">
            <h3>Still have questions?</h3>
            <p>Can't find the answer you're looking for? Our team is here to help you with any questions about our services.</p>
            <div className="faq-cta-buttons">
                <Link to="/#booking" className="btn-primary">Get Free Consultation</Link>
                <Link to="/#contact" className="btn-secondary">Contact Us Directly</Link>
              <Link to="/" className="btn-secondary">Go to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;